export default __webpack_public_path__ + "static/media/raider-125.b53f3baf.svg";